<template>
  <el-dialog
    :title="`AI${type == 1 ? '文本' : type == 2 ? '图片' : '视频'}生成`"
    center
    :visible.sync="dialogVisible"
    width="1200px"
    destroy-on-close
    @close="handleCancel"
  >
    <h3 v-if="type == 1">
      我们支持文字、图片与视频形式的内容输入，能将其统一转化为文字输出。针对生成的文字内容，我们可提供专业的润色服务；同时，若您能提供商品的详细信息或相关关键字，我们也能为您高效生成契合需求的商品文案！
    </h3>
    <h3 v-else-if="type == 2">
      我们可以根据您输入的文字提示词或者上传的产品图片，设计出各种风格的AI产品图供您选择
    </h3>
    <h3 v-else-if="type == 3">
      我们会根据您上传的产品图片或已选定的AI图片，设计出各种风格的产品视频供您选择
    </h3>

    <div class="img_upload">
      <div>
        <p class="mb-2">上传产品图:</p>
        <uploadAudioVue
          @success="formVal.imageUrl = $event"
          :value.sync="formVal.imageUrl"
          ref="uploadAudioRef"
        />
      </div>
      <div class="upload_video" v-if="type == 1">
        <p class="mb-2">上传产品视频:</p>
        <uploadVideoVue
          @success="handleUploadAudioSuccess"
          :value="{ url: formVal.urls }"
          ref="uploadVideoRef"
        />
      </div>
      <div class="tip">
        <p class="mb-2">输入提示词:</p>
        <div class="tip_txt">
          <el-input
            v-model="formVal.text"
            class="tip_ipt"
            resize="none"
            placeholder="想让AI更好地理解您的创意吗？请告诉我们您的构想：
       身在何处？（环境场景） 
       主角是什么？（商品主体）
       想要什么感觉？（风格调性）
       请用500字以内的关键词描述吧，尽情发挥您的想象力！"
            type="textarea"
            :rows="14"
            maxlength="500"
            show-word-limit
          ></el-input>
          <el-button
            type="warning"
            v-if="type == 2 || type == 3"
            class="tip_color"
            @click="aiCopyWriting(0)"
          >
            智能文本润色
          </el-button>
          <el-button
            type="success"
            @click="$refs.tipTemplateRef.open()"
            class="tip_template"
          >
            提示词模版
          </el-button>
        </div>
      </div>
    </div>
    <div v-if="type == 3" class="video-condition">
      <div>
        <span>视频品质：</span>
        <el-select
          v-model="formVal.mode"
          placeholder="请选择视频品质"
          style="width: 150px"
        >
          <el-option label="标准模式(标准)" value="std"></el-option>
          <el-option label="专家模式(高品质)" value="pro"></el-option>
        </el-select>
      </div>
      <div>
        <span>视频时长：</span>
        <el-select
          v-model="formVal.duration"
          placeholder="请选择视频时长"
          style="width: 150px"
        >
          <el-option label="5秒" value="5"></el-option>
          <el-option label="10秒" value="10"></el-option>
        </el-select>
      </div>
      <div>
        <span>视频个数：</span>
        <el-select
          v-model="formVal.count"
          placeholder="请选择视频个数"
          style="width: 150px"
        >
          <el-option label="1" :value="1"></el-option>
          <el-option label="2" :value="2"></el-option>
          <el-option label="3" :value="3"></el-option>
          <el-option label="4" :value="4"></el-option>
          <el-option label="5" :value="5"></el-option>
        </el-select>
      </div>
      <div>
        <span>首尾帧：</span>
        <el-switch v-model="formVal.imageTailUrl"> </el-switch>
      </div>
    </div>
    <el-button
      size="big"
      type="primary"
      :loading="loading"
      :disabled="loading"
      @click="aiWriting"
      >AI{{ typeText }}生成</el-button
    ><span v-if="loading" class="wait">AI生成中... ... 请勿刷新页面!</span>

    <!-- 文案列表 -->
    <div v-if="type == 1">
      <div class="tip" v-for="(item, idx) in currentPageData" :key="idx">
        <el-input
          ref="textareaRef"
          v-model="item.val"
          class="audioText"
          placeholder="AI文案"
          type="textarea"
          :rows="8"
          maxlength="1000"
          :disabled="item.disabled"
        ></el-input>
        <!--  -->

        <i
          class="el-icon-success text—checked"
          v-if="checkedText.id === item.id"
        ></i>
        <el-button type="warning" class="tip_color" @click="editText(idx)">
          编辑文本
        </el-button>
        <el-button
          type="success"
          v-if="checkedText.id !== item.id"
          class="tip_template"
          @click="handleTextSelect(item)"
        >
          使用文案
        </el-button>
        <el-button
          v-else
          type="success"
          class="tip_template"
          @click="handleTextUnSelect(item)"
        >
          取消文案
        </el-button>
      </div>
      <el-empty
        v-if="!textList.length"
        :description="`暂无AI${typeText}`"
      ></el-empty>
      <!-- 分页控制器 -->
      <div class="pagination-controls">
        <button
          @click="prevPage"
          :disabled="currentPage === 1"
          class="page-btn"
        >
          上一页
        </button>

        <span class="page-info">
          第 {{ currentPage }} 页 / 共 {{ totalPages }} 页
        </span>

        <button
          @click="nextPage"
          :disabled="currentPage === totalPages"
          class="page-btn"
        >
          下一页
        </button>

        <select
          v-model="pageSize"
          @change="resetPagination"
          class="page-size-select"
        >
          <option value="3">3条/页</option>
          <option value="6">6条/页</option>
          <option value="9">9条/页</option>
        </select>
      </div>
    </div>
    <!-- 产品图列表 -->
    <div v-if="type == 2" class="img_list">
      <el-empty
        v-if="!allImages.length"
        :description="`暂无AI${typeText}`"
      ></el-empty>
      <changeImageVue
        v-else
        :allImages="allImages"
        :type="typeText"
        :formVal="formVal"
        @select="handleImageSelect"
        :checkedImgsLength="checkedImgsLength"
        @generateVideo="toGenerateVideo"
      ></changeImageVue>
    </div>
    <!-- 视频列表 -->
    <div v-if="type == 3" class="img_list">
      <el-empty
        v-if="!allImages.length"
        :description="`暂无AI${typeText}`"
      ></el-empty>
      <changeImageVue
        v-else
        :allImages="allImages"
        :type="typeText"
        :formVal="formVal"
        @select="handleVideoSelect"
      ></changeImageVue>
    </div>
    <tipTemplateVue ref="tipTemplateRef" :type="type"></tipTemplateVue>
    <template #footer>
      <div>
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {
  reqAiImageWriting,
  reqAiVideoWriting,
  reqGoodsDetail,
  reqAiImageWritingResult,
  reqAiVideoWritingResult,
  reqSetGoods,
} from "@/assets/api/aiProduct";

import uploadAudioVue from "./uploadImage.vue";
import uploadVideoVue from "./uploadAudio.vue";
import aiDesignVue from "./aiDesign.vue";
import changeImageVue from "./changeImage.vue";
import tipTemplateVue from "./tipTemplate.vue";
import { EventSourcePolyfill } from "event-source-polyfill";
import { Typewriter } from "@/views/manage/aivideo/typeriter.js";

export default {
  components: {
    uploadAudioVue,
    uploadVideoVue,
    aiDesignVue,
    changeImageVue,
    tipTemplateVue,
  },
  data() {
    return {
      // 弹窗外层已上传图片 加上 选中图片的长度
      checkedImgsLength: 0,
      // 选中图片
      checkedImages: [],
      // 选中文案
      checkedText: {},
      // 选中视频
      checkedVideo: "",
      aiVideoTimer: [],
      dialogVisible: false,
      eventSource: null,
      loading: false,
      textList: [],
      list: [],
      allImages: [],
      formVal: {
        imageUrl: "",
        text: "",
        productId: "",
        productName: "",
        urls: "",
        duration: "5",
        count: 2,
        mode: "std",
        imageTailUrl: false,
      },
      timer: null,
      currentPage: 1,
      pageSize: 3,
      connectionStatus: "未连接",
      typewriter: null,
      txtValue: "",
      productNameList: [],
      // 1 文案 2 产品图 3 视频
      type: 1,
    };
  },

  destroyed() {
    clearInterval(this.timer);
    this.aiVideoTimer.forEach(function (timer) {
      clearInterval(timer);
    });
    this.aiVideoTimer = [];
    // 关闭已有连接
  },

  computed: {
    typeText() {
      if (this.type == 1) {
        return "文案";
      } else if (this.type == 2) {
        return "产品图";
      } else {
        return "视频";
      }
    },
    totalPages() {
      return Math.ceil(this.textList.length / this.pageSize);
    },
    currentPageData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + parseInt(this.pageSize);
      return this.textList.slice(start, end);
    },
  },
  methods: {
    handleCancel() {
      this.checkedImages = [];
      this.checkedImgsLength = 0;
      this.checkedText = {};
      this.checkedVideo = "";
      this.dialogVisible = false;
      this.eventSource = null;
      this.loading = false;
      this.textList = [];
      this.list = [];
      this.allImages = [];
      this.formVal = {
        imageUrl: "",
        text: "",
        productId: "",
        productName: "",
        urls: "",
        duration: "5",
        count: 2,
        mode: "std",
        imageTailUrl: false,
      };
      this.timer = null;
      this.currentPage = 1;
      this.pageSize = 3;
      this.connectionStatus = "未连接";
      this.typewriter = null;
      this.txtValue = "";
      this.productNameList = [];
      // 1 文案 2 产品图 3 视频
      this.type = 1;
      this.$emit("cancel");
    },
    handleConfirm() {
      if (this.type == 1 && !this.checkedText.val) {
        this.$message.error("请选择ai生成的内容");
        return;
      }
      if (this.type == 2 && this.checkedImages.length <= 0) {
        this.$message.error("请选择ai生成的图片");
        return;
      }
      if (this.type == 3 && !this.checkedVideo) {
        this.$message.error("请选择ai生成的视频");
        return;
      }
      this.$emit("confirm", {
        type: this.type,
        images: this.checkedImages,
        text: this.checkedText.val,
        videoUrl: this.checkedVideo,
      });
      this.handleCancel();
    },
    toGenerateVideo(data) {
      this.handleCancel();
      this.$nextTick(() => {
        setTimeout(() => {
          this.$emit("toGenerateVideo", data);
        }, 500);
      });
    },
    show(data) {
      this.type = data.type;
      this.formVal.imageUrl = data.imageUrl;
      data.productId && (this.formVal.productId = data.productId);
      this.formVal.productName = data.productName;
      data.imageUrl && this.$refs.uploadAudioRef.search(data.imageUrl);
      if (data.text) {
        this.formVal.text = data.text;
      } else {
        // this.queryGoods();
      }
      if (data.type == 2) {
        this.checkedImgsLength = data.checkedImgsLength || 0;
      }
      this.dialogVisible = true;
      if (data.imageToVideoQuick) {
        this.formVal.count = 1;
        this.formVal.duration = "10";
        this.formVal.mode = "pro";
        this.aiWriting();
      }
    },
    /**
     * 上传音频成功
     */
    handleUploadAudioSuccess(data) {
      this.formVal.urls = data.url;
    },
    // ai生产
    aiWriting() {
      if (!this.formVal.text) {
        this.$message.error("请输入提示词");
        return;
      }
      if (this.type == 1) {
        this.aiCopyWriting(1);
      } else if (this.type == 2) {
        this.aiImageWriting();
      } else {
        this.aiVideoWriting();
      }
    },
    handleImageSelect(images) {
      this.checkedImages = images;
      this.checkedImgsLength = this.checkedImgsLength + images.length;
      // this.$emit("imgSelect", row);
    },
    handleVideoSelect(row) {
      if (row.length > 0) {
        this.checkedVideo = row[0];
      } else {
        this.checkedVideo = "";
      }
    },
    async handleTextSelect(row) {
      this.checkedText = row;
    },
    handleTextUnSelect(row) {
      this.checkedText = {};
    },
    // AI文字生成
    async aiCopyWriting(way) {
      this.loading = true;
      let type;
      if (this.formVal.urls) {
        if (this.formVal.urls && this.formVal.imageUrl) {
          type = 2;
        } else {
          type = 3;
        }
      } else if (way == 1) {
        if (!this.formVal.urls && !this.formVal.imageUrl) {
          type = 1;
        } else {
          type = 2;
        }
      } else if (way == 0) {
        type = 1;
      }
      this.connectSSE(way, type);
    },
    // AI图片生成
    async aiImageWriting() {
      this.loading = true;
      const res = await reqAiImageWriting({
        text: this.formVal.text,
        productId: this.formVal.productId,
        productName: this.formVal.productName,
        imageCount: 2,
        imageUrl: this.formVal.imageUrl,
        aspectRatio: "1:1",
      });
      if (res.code == 200) {
        const taskId = res.data;
        this.timer = setInterval(async () => {
          const result = await reqAiImageWritingResult({ taskId });
          if (result.code == 200) {
            this.$message.success("生成成功!");
            this.allImages.unshift(
              ...result.data.map((item) => {
                return {
                  url: item.aiContent,
                  id: item.id,
                  aiContent: item.aiContent,
                };
              })
            );
            this.loading = false;
            clearInterval(this.timer);
          } else {
            this.$message.warning("AI生成中 请耐心等待!");
          }
        }, 5000);
      } else {
        this.$message.warning(res.message);
        this.loading = false;
      }
    },
    // AI 视频生成
    async aiVideoWriting() {
      this.loading = true;
      try {
        const res = await reqAiVideoWriting({
          text: this.formVal.text,
          productId: this.formVal.productId,
          productName: this.formVal.productName,
          imageUrl: this.formVal.imageUrl,
          mode: this.formVal.mode,
          duration: this.formVal.duration,
          count: this.formVal.count,
          imageTailUrl: this.formVal.imageTailUrl
            ? this.formVal.imageUrl
            : undefined,
        });

        if (res.code == 200) {
          const taskIds = res.data; // taskId 是一个字符串数组
          this.pollVideoTasks(taskIds); // 开始轮询所有 taskId
        } else {
          this.$message.warning(res.message);
          this.loading = false;
        }
      } catch (error) {
        this.$message.error("视频生成请求失败: " + error.message);
        this.loading = false;
      }
    },

    // 并发轮询所有 taskId，收集成功结果
    async pollVideoTasks(taskIds) {
      this.loading = true;
      const successfulResults = [];

      // 并发启动所有任务的轮询
      const pollPromises = taskIds.map((taskId) =>
        this.pollSingleTask(taskId)
          .then((result) => {
            // 成功的结果存入 successfulResults
            if (result.code == 200) {
              successfulResults.push(
                ...result.data.map((item) => ({
                  url: item.aiContent,
                  id: item.id,
                  aiContent: item.aiContent,
                }))
              );
            }
          })
          .catch((error) => {
            // 失败的任务只提示错误，不抛出异常
            this.$message.error(`任务 ${taskId} 生成失败: ${error.message}`);
          })
      );

      // 等待所有轮询任务完成（无论成功或失败）
      await Promise.allSettled(pollPromises);

      // 处理成功的结果
      if (successfulResults.length > 0) {
        this.allImages.unshift(...successfulResults);
        this.$message.success(`成功生成 ${successfulResults.length} 个视频!`);
      } else {
        this.$message.warning("没有任务成功生成视频");
      }

      this.loading = false;
    },

    // 轮询单个 taskId
    pollSingleTask(taskId) {
      return new Promise((resolve, reject) => {
        const interval = setInterval(async () => {
          try {
            const result = await reqAiVideoWritingResult({ taskId });
            if (result.code == 200) {
              clearInterval(interval); // 任务完成，停止轮询
              resolve(result); // 返回结果
            } else {
              this.$message.warning(`任务 ${taskId} 生成中，请耐心等待!`);
            }
          } catch (error) {
            clearInterval(interval); // 出错时停止轮询
            this.aiVideoTimer = this.aiVideoTimer.filter((t) => t !== interval);
            reject(error); // 抛出错误
          }
        }, 5000); // 每 5 秒轮询一次
        this.aiVideoTimer.push(interval);
      });
    },
    editText(idx) {
      this.textList[idx].disabled = false;
    },
    reset() {
      this.formVal.productId = "";
      this.formVal.productName = "";
      this.$refs.uploadAudioRef.handleRemove();
    },
    /**
     * 获取商品数据
     */
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    resetPagination() {
      this.currentPage = 1;
    },
    // 查询商品信息
    async queryGoods() {
      const res = await reqGoodsDetail({
        productId: this.formVal.productId,
        productName: this.formVal.productName,
        generateType: this.type,
      });
      if (res.code == 200) {
        this.productNameList = res.data;
        // 存在记录
        if (res.data.length && res.data[0].existRecord) {
          this.formVal.imageUrl = res.data[0].imageUrl;
          this.$refs.uploadAudioRef.search(res.data[0].imageUrl);
          this.formVal.text = res.data[0].prompt;
          this.$message.success("搜索成功,已自动恢复到上次生成记录!");
        } else {
          this.$message.success("该商品暂无生成记录");
        }
      } else {
        this.$message.warning(res.message);
      }
    },
    connectSSE(way, type) {
      this.textList.unshift({
        val: "",
        id: "",
        disabled: true,
      });
      // this.closeSSE();

      const params = new URLSearchParams({
        type,
        text: this.formVal.text,
        productId: this.formVal.productId,
        productName: this.formVal.productName,
        urls: this.formVal.imageUrl || this.formVal.urls,
      });
      const url =
        process.env.VUE_APP_API +
        `/aistream/api/merchant/product/ai-text-stream/add?${params.toString()}`;

      this.eventSource = new EventSourcePolyfill(url, {
        headers: {
          Authorization: localStorage.getItem("token"),
          withCredentials: true,
        },
      });

      this.eventSource.onopen = (e) => {
        this.connectionStatus = "已连接";
        // console.log("SSE连接已建立", e);
      };
      let cleared = false;

      this.eventSource.onmessage = (e) => {
        this.txtValue += JSON.parse(e.data).message;
        if (way == 1) {
          this.textList[0].val += JSON.parse(e.data).message;
        } else {
          if (way == 0) {
            if (!cleared) {
              cleared = true;
              this.formVal.text = "";
            }
          }

          this.formVal.text += JSON.parse(e.data).message;
        }
        if (JSON.parse(e.data).aiProductResult) {
          this.textList[0].id = JSON.parse(e.data).aiProductResult.id;
          this.loading = false;
          this.closeSSE();
        }
      };

      this.eventSource.onerror = (e) => {
        this.loading = false;

        if (e.readyState === EventSource.CLOSED) {
          this.connectionStatus = "连接已关闭";
        } else {
          this.connectionStatus = "连接异常";
        }
      };
    },
    processGPTResponse(data) {
      // 4. 逐字渲染实现
      if (!this.typewriter) {
        this.typewriter = new Typewriter(this.$refs.textareaRef, {
          speed: 50, // 控制打字速度(ms/字符)
          onComplete: () => {
            this.scrollToBottom();
          },
        });
      }

      // 5. 处理GPT流式数据
      if (data) {
        const char = this.typewriter.add(data);
      }
    },

    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.textareaRef.scrollTop = this.$refs.textareaRef.scrollHeight;
      });
    },
    closeSSE() {
      console.log("closeSSE");
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
        this.connectionStatus = "已断开";
      }
    },
  },
};
</script>
<style scoped lang="scss">
h3 {
  margin: 20px 0;
}

.img_upload {
  display: flex;
  margin-bottom: 20px;
  .tip {
    margin: 0;
    margin-left: 50px;
    width: 800px;
  }
}

.tip {
  position: relative;
  margin: 20px 0;
  .text—checked {
    position: absolute;
    right: 16px;
    top: 16px;
    font-size: 24px;

    color: #67c23a;
  }
  .tip_txt {
    height: 375px;
    overflow: auto;
    border: 1px solid #dcdfe6;
    position: relative;
  }
  .tip_ipt {
  }
  .tip_template {
    position: absolute;
    bottom: 16px;
    right: 16px;
  }
  .tip_color {
    position: absolute;
    bottom: 16px;
    right: 136px;
  }
}
.img_list {
  // display: flex;
  margin: 20px 20px 20px 0;
  width: 100%;
}
.next {
  width: 120px;
  height: 40px;
}
.img_item {
  position: relative;
  width: 400px;
  height: 280px;
  margin-right: 20px;
  margin-bottom: 20px;
  .mask {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    &:nth-child(2) {
      height: 25%;
      top: 35%;
    }
  }
  .tip_template {
    position: absolute;
    bottom: -20px;
    right: 0;
  }
  .tip_color {
    position: absolute;
    bottom: -20px;
    right: 120px;
  }
  .select {
    display: none;
    position: absolute;
    top: 140px;
    left: 150px;
    z-index: 9;
  }
}
.img_item:hover .mask,
.img_item:hover .select {
  display: flex;
}
.upload_video {
  margin-left: 20px;

  p {
    margin-bottom: 300px;
  }
}
.video-content {
  width: 400px;
  height: 300px;
}
.wait {
  color: #999;
  margin-left: 20px;
}
.pagination-wrapper {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.data-list {
  margin-bottom: 20px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
}

.data-item {
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  transition: background 0.3s;
}

.data-item:hover {
  background: #f5f5f5;
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.page-btn {
  padding: 8px 16px;
  background: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: opacity 0.3s;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.page-size-select {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
}
.mb-2 {
  margin-bottom: 8px;
}
.video-condition {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}
::v-deep .el-textarea__inner {
  border: none;
}
</style>
